import { useEffect, useState } from "react";
import api from "../lib/api";
import { todoLines } from "../lib/dashboard";
import { appCounts } from "../lib/apps";

// What waits in each application, from the dashboard's own « À traiter » block (one request, same figures as the home page).
// Read when the centre opens; a server without the block (404) or an error simply shows no figure, never a false 0.
export default function useAppCounts(apps, active) {
  const [lines, setLines] = useState([]);
  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    api.get("/dashboard/blocks/todo")
      .then(({ data }) => { if (!cancelled) setLines(todoLines(data.data)); })
      .catch(() => { if (!cancelled) setLines([]); });
    return () => { cancelled = true; };
  }, [active]);
  return appCounts(apps, lines);
}
